import { Component } from '@angular/core';
import { AdministratorFacade, customEncrypt } from '@piqet-angular/data';
import { CustomModalService, clickTooltipDef, commonEnum } from '@piqet-angular/shared';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { forEach } from 'lodash';

@Component({
  selector: 'piqet-angular-grid-cell-link',
  templateUrl: './grid-cell-link.component.html',
  styleUrls: ['./grid-cell-link.component.css'],
})
export class GridCellLinkComponent implements ICellRendererAngularComp {
  params: any;
  userFirstName: any;
  teamName: any;
  isNews: any;
  logEntry: any;
  isAdminOrganizationDetail: any;
  showFullContent: boolean = false;
  showFullContentError: boolean = false;
  importsLink: any;
  stackTrace: any;
  errorMessage: any;
  errorMessageLink: any;
  commonEnum = commonEnum;
  clickTooltipDef = clickTooltipDef;
  encryptedUserId: string = '';

  async agInit(params: ICellRendererParams<any, any>): Promise<void> {
    this.params = params;
    this.userFirstName = this.params.colDef.colId == 'FirstName' ? true : false;
    this.teamName = this.params.colDef.colId == 'Name' ? true : false;
    this.isNews = this.params.colDef.colId == 'Subject' ? true : false;
    this.isAdminOrganizationDetail =
      this.params.colDef?.cellRendererParams?.gridName == 'organization' ? true : false;
    this.logEntry = this.params.colDef?.cellRendererParams?.gridName == 'logentries' ? true : false;
    this.importsLink =
      this.params.colDef?.cellRendererParams?.gridName == 'stackTrace' ? true : false;
    this.stackTrace = this.importsLink ? this.params?.data?.stackTrace : '';
    this.errorMessageLink =
      this.params.colDef?.cellRendererParams?.gridName == 'errorMessage' ? true : false;
    this.errorMessage = this.errorMessageLink ? this.params?.data?.errorMessage : '';
    const id =
      this.params?.data?.userId || this.params?.data?.id || this.params?.data?.organizationId;
    if (id) {
      this.encryptedUserId = customEncrypt(id);
    }
  }

  constructor(
    public administratorFacade: AdministratorFacade,
    private administratorService: AdministratorService,
    private modal: CustomModalService
  ) {}

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  async projectRouting(data: any, pathName: any) {
    const res = await this.administratorService.getAuditHistoryDetailModal(
      data.id,
      data.primaryId,
      data.tableName
    );

    this.modal.invoke('newViewLogEntries', {
      initialState: {
        newViewLogEntriesData: res.data,
        headerName: 'View log entries',
      },
      class: 'modal-xl',
    });
  }

  // Email verification methods
  resendUserEmail() {
    this.params?.resendMail(this.params.data);
  }

  verifyUserEmail() {
    this.params?.verifyMail(this.params.data);
  }

  // User activation method
  activateUser() {
    this.params?.activateUser(this.params.data);
  }

  // Reviewer verification method
  reviewerVerified() {
    this.params?.verifyReviewer(this.params.data);
  }
}
